export default "__VITE_ASSET__BQ9STg3n__"